// import React, { useEffect } from 'react';
// import { Container, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { useFetchOrganizationsQuery } from '../../services/profileService';
// import AddIcon from "@mui/icons-material/Add";

// const ViewOrganizations = () => {
//   const navigate = useNavigate();
//   const { data: organizations, isLoading, refetch } = useFetchOrganizationsQuery();

//   useEffect(() => {
//     refetch();
//   }, [refetch]);

//   const handleAddOrganization = () => {
//     navigate('/superadmin-dashboard'); // Redirect to Add Organization page
//   };

//   // const handleBack = () => {
//   //   navigate("/view-org");
//   // };

//   if (isLoading) return <Typography>Loading organizations...</Typography>;

//   return (
//     <Container>
//       <Typography variant="h4" sx={{ mb: 2 ,mt:3}}>List of Organizations</Typography>

//       {/* <Button
//         variant="contained"
//         color="primary"
//         onClick={handleAddOrganization}
//         sx={{ mb: 4 }}
//       >
//         Add Organization
//       </Button> */}
//       <Button
//           variant="contained"
//           color="primary"
//           startIcon={<AddIcon />}  // Add the icon before the text
//           sx={{
//             marginLeft: 2,
//             top: '5px',
//             marginBottom:4,
//             right: '10px',
//             fontSize: '16px',  // Text size adjustment
//             padding: '8px 16px',  // Padding adjustment for the button
//             '&:hover': {
//               backgroundColor: '#e3f2fd',  // Light blue background on hover
//             },
//           }}
//           onClick={handleAddOrganization}
//         >
//           Add Organization  {/* Display the text next to the icon */}
//         </Button>

//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Organization Name</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {organizations?.data?.map((organization) => (
//               <TableRow key={organization.id}>
//                 <TableCell>{organization.name}</TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Container>
//   );
// };

// export default ViewOrganizations;

import React, { useEffect } from "react";
import {

  Typography,
  Button,

  styled,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useFetchOrganizationsQuery } from "../../services/profileService";
import AddIcon from "@mui/icons-material/Add";
import { DataGrid } from "@mui/x-data-grid";

const ViewOrganizations = () => {
  const navigate = useNavigate();
  const {
    data: organizations,
    isLoading,
    refetch,
  } = useFetchOrganizationsQuery();

  useEffect(() => {
    refetch();
  }, [refetch]);

  const handleAddOrganization = () => {
    navigate("/superadmin-dashboard"); // Redirect to Add Organization page
  };

  const handleViewDetails = (id) => {
    navigate(`/organizations/${id}`);
  };

  const handleEditOrganization = (id) => {
    navigate(`/organizations/${id}/edit`);
  };

  const handleResetPassword = (id) => {
    navigate(`/organizations/${id}/reset-password`);
  };

  if (isLoading) return <Typography>Loading organizations...</Typography>;

  const columns = [
    {
      field: "id",
      headerName: "ID",
      minWidth: 100,
    },
    {
      field: "name",
      headerName: "Organization Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 400,
      sortable:false,
      renderCell: (params) => (
        <>
          <CustomBtn
            sx={{ background: "#1085AB", borderColor: "#1085AB" }}
            onClick={() => handleViewDetails(params.row.id)}
          >
            View Details
          </CustomBtn>
          <CustomBtn onClick={() => handleEditOrganization(params.row.id)}>
            Edit
          </CustomBtn>
          <CustomBtn
            sx={{ background: "#d32f2f", borderColor: "#d32f2f" }}
            onClick={() => handleResetPassword(params.row.id)}
          >
            Reset Password
          </CustomBtn>
        </>
      ),
    },
  ];

  const rows = organizations?.data?.map((organization) => ({
    id: organization.id,
    name: organization.name,
  }));

  return (
    <>
      <SectionWrap component="section">
        <ContainerWrap>
          <RowWrap sx={{ marginBottom: "10px" }}>
            <Col12Wrap>
              <TitleWrap
                sx={{ textTransform: "capitalize", marginBottom: "0" }}
              >
                List of Organizations
              </TitleWrap>
            </Col12Wrap>
          </RowWrap>
          <RowWrap sx={{ marginBottom: "20px", alignItems: "center" }}>
            <Col12Wrap>
              <CustomBtn
                sx={{
                  padding: "7px 10px",
                  margin: "0",
                  "& .MuiButton-icon": { marginRight: "3px", marginLeft: "0" },
                }}
                startIcon={<AddIcon />}
                onClick={handleAddOrganization}
              >
                Add Organization
              </CustomBtn>
            </Col12Wrap>
          </RowWrap>
          <RowWrap>
            <Col12Wrap>
              <TableContentwrap>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 30,
                      },
                    },
                  }}
                  pageSizeOptions={[30]}
                  disableRowSelectionOnClick
                  disableColumnMenu={true}
                  sx={{
                    "& .MuiDataGrid-iconButtonContainer": {
                      visibility: 'visible !important',
                      width: 'auto !important',
                      "svg": {
                        opacity:'1 !important',
                      }
                    } 
                  }}
                />
              </TableContentwrap>
            </Col12Wrap>
          </RowWrap>
        </ContainerWrap>
      </SectionWrap>
    </>
  );
};

export default ViewOrganizations;

const SectionWrap = styled(Box)(() => ({
  padding: "30px 0",
}));
const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const TitleWrap = styled(Typography)(() => ({
  fontSize: "28px",
  fontWeight: "600",
  lineHeight: "1.445",
  color: "#000000",
  marginBottom: "15px",
}));
const CustomBtn = styled(Button)(() => ({
  minWidth: "auto",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "5px",
  padding: "10px",
  margin: "0 5px",
  boxShadow: "none !important",
}));
const TableContentwrap = styled(Box)(() => ({
  padding: "15px",
  background: "#ffffff",
  borderRadius: "7px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
}));
